import React, { useState, useEffect } from 'react';
import Head from 'next/head'
import { APIURL, PAGEURL } from './../../constants'
import services from './../../components/services'
import Link from 'next/link'
import { faqPathSlug, faqPathToLookupQuestion } from '../../utils/faqUrls'
import { getFaqSeo } from '../../utils/contentSeo'
import { pickerH1Label } from '../../utils/pickerSeo'


function FAQComponent(props) {
  const question = props.question;
  const faq = props.faq;
  const { answer, created_at, description, topic_slug, topic_name } = props.faq
  const seo = getFaqSeo(question) || {}
  const pageTitle = seo.title || question
  const pageDescription = seo.description || description

  return (
    <div className="home home-blog">
      <Head>
        <title>{pageTitle}</title>
        <meta name='description' content={pageDescription}/>
      </Head>
      <div className="blog-title-block faq">
        <div>
          <h1 className="title-left faq">
            {question}
          </h1>
        </div>
      </div>
      <div className="blog-container">
        <div className="blog-post">
          <div className="blog" dangerouslySetInnerHTML={{ __html: answer }} ></div>
          <div className='blog pt-md'>
            Ready for a personalized match? Try our{' '}
            <Link href={PAGEURL.PRODUCT_PICKER(topic_slug, '0')}>
              <span className='orange-link'>{pickerH1Label(topic_name)}</span>
            </Link>
            {' '}to find the right one for you in minutes.
          </div>
          <div className="mt-lg iframe">
          <iframe src={"https://simplybuy.io/iframe/"+topic_slug+"/0?src=faq"} scrolling="auto" title={`${topic_name} picker`}>
          </iframe>
          </div>
        </div>
      </div>
    </div>
  )
}

export async function getServerSideProps(context) {
  let { question } = context.query;
  const raw = Array.isArray(question) ? question[0] : question
  if (!raw) {
    return { notFound: true }
  }

  // Permanently redirect legacy paths that still include a trailing "?" / %3F
  // so Google consolidates to the clean URL without changing DB question text.
  if (raw.endsWith('?') || /%3F$/i.test(raw)) {
    const cleanSlug = faqPathSlug(faqPathToLookupQuestion(raw))
    return {
      redirect: {
        destination: `/FAQs/${cleanSlug}`,
        permanent: true,
      },
    }
  }

  try {
    const lookupQuestion = faqPathToLookupQuestion(raw)
    const response = await services.get_v2(APIURL.GET_FAQ, {
      params: { question: lookupQuestion }
    });
    if (response.status && response.status === 'failure') {
      return {
         notFound: true,
       }
    } else {
       return {
         props: {
           question: response.question,
           faq: response,
         },
       }
    }
  } catch (error) {
    return {
      notFound: true,
    };
  }
}

// BlogComponent.getLayout = function getLayout(page) {
//   return (
//     <DefaultLayout>
//       {page}
//     </DefaultLayout>
//   )
// }

// BlogComponent.getInitialProps = async (props) => {
//   const { title } = props.query
//   return { title: title }
// }

// export function getServerSideProps (context) {
//     console.log(context.query)
//     // returns { id: episode.itunes.episode, title: episode.title}
//
//
//     //you can make DB queries using the data in context.query
//     return {
//         props: {
//            title: context.query.title,
//            id: context.query.id//pass it to the page props
//         }
//     }
// }

export default FAQComponent
